import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ReversalSuspendService from "services/lms/suspend/reversalSuspendService";
import { notification } from "antd";

export const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  reversalSuspendList: [],
  getCount: 0,
};

export const fetchgetReversalSuspend = createAsyncThunk(
  "reversalSuspend/fetchgetReversalSuspend",
  async (data) => {
    try {
      const response = await ReversalSuspendService.getReversalSuspend(data);
      return response.data;
    } catch (error) {
      console.error("Error fetching reversal suspends:", error);
      throw error;
    }
  },
);

export const addReversalSuspend = createAsyncThunk(
  "reversalSuspend/addReversalSuspend",
  async (data) => {
    try {
      const response = await ReversalSuspendService.addReversalSuspend(data);
      if (response.status === 200) {
        if (response.data.status === "Success") {
          notification.success({
            message: "Success",
            description: "Reversal Suspend berhasil ditambahkan",
          });
          return response.data;
        }
      } else {
        notification.error({
          message: "Error",
          description: "Gagal menambahkan Reversal Suspend",
        });
      }
    } catch (error) {
      console.error("Error adding reversal suspend:", error);
      notification.error({
        message: "Error",
        description: "Gagal menambahkan Reversal Suspend",
      });
      throw error;
    }
  },
);

export const postSuspendReversal = createAsyncThunk(
  "reversalSuspend/postSuspendReversal",
  async (data) => {
    try {
      const response = await ReversalSuspendService.postSuspendReversal(data);
      if (response.status === 200) {
        if (response.data.status === "Success") {
          notification.success({
            message: "Success",
            description: "Reversal Suspend berhasil ditambahkan",
          });
          return response.data;
        } else {
          notification.error({
            message: response.data.status ?? "Error",
            description: response.data.message ?? "Gagal menambahkan Reversal Suspend",
          });
          return response.data;
        }
      } else {
        notification.error({
          message: "Error",
          description: "Gagal menambahkan Reversal Suspend",
        });
      }
    } catch (error) {
      console.error("Error posting suspend reversal:", error);
      notification.error({
        message: "Error",
        description: error?.response?.data?.message ?? "Gagal menambahkan Reversal Suspend",
      });
      throw error;
    }
  },
);

export const fetchApproveReversal = createAsyncThunk(
  "reversalSuspend/fetchApproveReversal",
  async (data) => {
    try {
      const response = await ReversalSuspendService.fetchApproveReversal(data);
      if (response.status === 200) {
        if (response.data.status === "Success") {
          notification.success({
            message: "Success",
            description: "Reversal Suspend berhasil diapprove",
          });
          return response.data;
        } else {
          notification.error({
            message: response.data.status ?? "Error",
            description: response.data.message ?? "Gagal approve reversal suspend",
          });
          return response.data;
        }
      } else {
        notification.error({
          message: "Error",
          description: "Gagal approve reversal suspend",
        });
      }
    } catch (error) {
      console.error("Error approving reversal suspend:", error);
      notification.error({
        message: "Error",
        description: error?.response?.data?.message ?? "Gagal approve reversal suspend",
      });
      throw error;
    }
  },
);

const reversalSuspendSlice = createSlice({
  name: "reversalSuspend",
  initialState,
  reducers: {
    resetReversalSuspendState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.error = null;
      state.reversalSuspendList = [];
      state.getCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchgetReversalSuspend.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchgetReversalSuspend.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reversalSuspendList = action.payload;
        state.getCount = action.payload?.count || 0;
      })
      .addCase(fetchgetReversalSuspend.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(addReversalSuspend.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(addReversalSuspend.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = action.payload?.status === "Success";
      })
      .addCase(addReversalSuspend.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.error.message;
      })
      .addCase(postSuspendReversal.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(postSuspendReversal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = action.payload?.status === "Success";
      })
      .addCase(postSuspendReversal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.error.message;
      })
      .addCase(fetchApproveReversal.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(fetchApproveReversal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = action.payload?.status === "Success";
      })
      .addCase(fetchApproveReversal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.error.message;
      });
  },
});

export const { resetReversalSuspendState } = reversalSuspendSlice.actions;
export default reversalSuspendSlice.reducer;
